import script from "./ForgotPasswordView.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgotPasswordView.vue?vue&type=script&setup=true&lang=js"

import "@/views/auth/ForgotPasswordView.css?vue&type=style&index=0&id=42730ce5&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42730ce5"]])

export default __exports__